const branchType = {
  path: "",
  name: "",
  redirect: "/branchType",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/branchType",
      redirect: "/branchType",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Branch Type",
      meta: {
        requiresAuth: true,
        activeUrl: "/branchType",
        parent: "/branchType",
        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/branchType"),
          meta: {
            requiresAuth: true,
            activeUrl: "/branchType",
            parent: "/branchType",
            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Branch Type Detail",
          component: () => import("@/views/pages/branchType/detail"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/branchType",
            parent: "/branchType",
            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};

export default branchType;
